import { HtmlId } from '../enum';
import { createNotification, Notification } from '@vfde-brix/ws10/notification';
import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { CmsAvailabilityNotification } from '../interface';
import notificationUtils from '../util/component/notification.utils';
import { ProductAvailability } from '../container/AddressValidation/interface';

/**
 * Create Brix Notification component.
 * @param {HtmlId} id - ID of the element.
 * @returns {Notification | null} component or null if element with given id is not found
 */
export const mountNotification = (id: HtmlId) =>
    createComponentById(createNotification, id, NO_PATTERN_BUSINESS_LOGIC);

export const updateResultNotification = (
    comp: Notification | null,
    cmsProps: CmsAvailabilityNotification,
    availability: ProductAvailability,
) => {
    if (!comp) {
        return;
    }

    const props = comp.getProperties();

    props.optState = notificationUtils.getResultState(availability.cableTv);
    props.stdHeadline = notificationUtils.getResultHeadline(cmsProps, availability.cableTv);
    props.txtContent = notificationUtils.getResultSubline(cmsProps, availability);
    props.containerButtons = notificationUtils.getResultContainerButtons(cmsProps, availability);

    comp.update(props);
};
